import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type Props = {
  sessionCount: number;
  totalPins: number;
  startDate: string;
};

const strings = STRINGS.guardian.playerSessionHistories;
const SUMMARY_SEPARATOR = '\u2022';

const SessionHistorySummary = ({ sessionCount, totalPins, startDate }: Props) => {
  const styles = useStyles();
  const { scale } = useScaling();
  const hasStartDate = startDate.trim().length > 0;

  return (
    <Stack
      direction="row"
      align="center"
      justify="space-between"
      gap={scale(12)}
      style={styles.summary}>
      <Stack direction="row" align="center" gap={scale(4)} style={styles.summaryTextGroup}>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
          numberOfLines={1}
          style={styles.summaryText}>
          {strings.sessionsSummary(sessionCount)}
        </Text>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
          numberOfLines={1}
          style={styles.summarySeparator}>
          {SUMMARY_SEPARATOR}
        </Text>
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
          numberOfLines={1}
          style={styles.summaryText}>
          {strings.pinsEarnedSummary(totalPins)}
        </Text>
      </Stack>
      {hasStartDate ? (
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 12 Regular"
          numberOfLines={1}
          style={styles.sinceText}>
          {strings.since.replace('{date}', startDate)}
        </Text>
      ) : null}
    </Stack>
  );
};

const useStyles = createStyles(({ scale }) => ({
  summary: {
    paddingTop: scale({ phone: 8, tablet: 20 }),
  },
  summaryTextGroup: {
    flexShrink: 1,
  },
  summaryText: {
    color: guardianColors['10'],
  },
  summarySeparator: {
    color: guardianColors['5'],
    flexShrink: 0,
  },
  sinceText: {
    color: guardianColors['6'],
    flexShrink: 0,
  },
}));

export default SessionHistorySummary;
